// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	SendIdvButton: 'send-idv-button',
	PurchaserResideInPropertyCheckbox: 'purchaser-reside-in-property-checkbox',
	ClientsContentHeader: 'clients-content-header',
	DetailsSection: 'details-section',
	ClientBrokerageSection: 'client-brokerage-section',
	ClientIntakeSection: 'client-intake-section',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
